import { useRecoilValue } from 'recoil';
import { permissionsSelector } from 'common/state/account';
import { useGetAllFeaturesGates, useIsCustomerDataExportEnabled } from 'common/hooks/features';

/**
 * Single gate for the Data export settings tab and page: the user can manage members (`user_edit`)
 * and the customer has the `customer_data_export` feature. The backend enforces the same rule.
 */
export const useCanManageDataExport = (): { canManage: boolean; isLoading: boolean } => {
  const { user_edit: isAdmin } = useRecoilValue(permissionsSelector);
  const isEnabled = useIsCustomerDataExportEnabled();
  const { isLoading } = useGetAllFeaturesGates();

  return { canManage: isAdmin && isEnabled, isLoading };
};
